import request from '../http';

// 获取文件夹树（filterByOwner=true 则按当前用户归属过滤）
export const listFolderTree = (params) =>
  request({ url: '/material/folders/tree', method: 'get', params });

// 创建文件夹
export const createFolder = (data) =>
  request({ url: '/material/folders', method: 'post', data });

// 更新文件夹
export const updateFolder = (id, data) =>
  request({ url: `/material/folders/${id}`, method: 'put', data });

// 删除文件夹
export const deleteFolder = (id) =>
  request({ url: `/material/folders/${id}`, method: 'delete' });

// 移动文件夹
export const moveFolder = (id, data) =>
  request({ url: `/material/folders/${id}/move`, method: 'put', data });

// 文件夹批量打标签
export const batchTagFolder = (id, tagIds, mode) =>
  request({ url: `/material/folders/${id}/tags`, method: 'put', data: { tagIds, mode } });

// 查询所有一级文件夹的归属信息
export const listFolderOwnership = () =>
  request({ url: '/material/folders/ownership', method: 'get' });

// 设置一级文件夹归属用户（ownerUserId 为 null 表示取消归属）
export const setFolderOwner = (id, ownerUserId) =>
  request({ url: `/material/folders/${id}/owner`, method: 'put', data: { ownerUserId } });

// 获取可选归属用户列表
export const listOwnerUsers = () =>
  request({ url: '/material/folders/owner-users', method: 'get' });
